import makeCrud from '@/store/site/localization/crud'

const module = makeCrud('ecommerce_order_draft')

// Taslağı gerçek siparişe çevir
module.actions.convert = async function (_, {id}) {
    const res = await this._vm.axios.post(this._vm.endpoint.get('ecommerce_order_draft') + '/' + id + '/convert')
    return res.data
}

export default module
